// Error texts in the member's language, set on <body> by includes/main_header.html.twig
// and error_main.html.twig.

type ErrorText = "generic" | "rateLimited" | "proxy";

const datasetKeys: Record<ErrorText, string> = {
  generic: "errorGeneric",
  rateLimited: "errorRateLimited",
  proxy: "errorProxy",
};

export const errorText = (text: ErrorText): string =>
  document.body.dataset[datasetKeys[text]] ?? "";

/** A failure whose message is already in the member's language. */
export class ShownError extends Error {}

/** Shows a failed request: its own text when it has one, the generic text otherwise. */
export const alertFailure = (error: unknown) => {
  alert(error instanceof ShownError ? error.message : errorText("generic"));
};
